import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

export function BaseModal({
    open,
    onOpenChange,
    title,
    description,
    children,
    footer,
    className,
    contentClassName,
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className={cn("sm:max-w-[500px] gap-6", className)}>
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold leading-none tracking-tight text-primary">
                        {title}
                    </DialogTitle>
                    {description && (
                        <DialogDescription className="text-sm text-muted-foreground mt-2">
                            {description}
                        </DialogDescription>
                    )}
                </DialogHeader>
                <div className={cn("py-2", contentClassName)}>
                    {children}
                </div>
                {footer && <DialogFooter className="gap-2 sm:gap-0">{footer}</DialogFooter>}
            </DialogContent>
        </Dialog>
    );
}
